/*eslint-disable*/

export const questions = [
  {
    id: 1,
    title: "What is Oya about?",
    answer: "Oyaghana is digitizing the intercity transport services.",
  },
  {
    id: 2,
    title: 'Do you work with only gprtu',
    answer: 'No, other transport companies like Concern Drivers Association, Cooperative Drivers Association, and others are in the process of being added...'
  },
  {
    id: 3,
    title: 'Do you work 24/7',
    answer: 'Yes'
  },
  {
    id: 4,
    title: 'How can we reach you?',
    answer: 'Contact page or live agent on oyaghana.com, Call/Whatsapp on  020 865 9922'
  },
  {
    id: 5,
    title: 'What is midroute service',
    answer: 'Passengers who download the Oya App, are able to buy fare and join the bus at designated points on its route.'
  },
  {
    id: 6,
    title: 'Can I pay electronically?',
    answer: 'Yes, by MTN Momo, Vodacash and Airtigo Cash'
  },
  {
    id: 7,
    title: 'How do I report over-speeding?',
    answer: 'Whilst in the bus, you can rate the driving, and you can also use the overspeeding widget to report overspeeding. '
  },
  {
    id: 8,
    title: 'How do I retrieve a missing package',
    answer: 'Call helpdesk line on 020 865 9922'
  },
  {
    id: 9,
    title: 'My transport company is a small one, will your platform work for me?',
    answer: 'Yes, we support both small and large transport companies'
  },
  {
    id: 10,
    title: 'What are your primary services',
    answer: 'BusRide Service, Parcel Service , Hiring Service and Cargo-Truck Services.'
  },
  {
    id: 11,
    title: 'Do I have to subscrie to Use the App',
    answer: 'There is no subscription in using the app. Its absolutely free!'
  }
]
